import React from "react";
import { useSelector } from "react-redux";

interface CardColProps {
  title?: string;
  subTitle?: string | number;
  amount?: boolean;
  units?: boolean;
  simple?: boolean;
  percentage?: boolean;
  forTxn?: boolean;
  report?: boolean;
  normal_num?: boolean;
}

const CardColComponent: React.FC<CardColProps> = ({
  title = "",
  subTitle = "",
  amount = false,
  units = false,
  simple = false,
  percentage = false,
  forTxn = false,
  report = false,
  normal_num = false,
}) => {
  const theme = useSelector((state: any) => state.ThemeModeReducer.Theme);
  const [whole, decimal] = subTitle?.toString().split(".") ?? ["0", "00"];

  const renderTxnAmountPattern = () => {
    const [whole1, decimal1] = title?.toString().split(".") ?? ["0", "00"];
    const [whole2, decimal2] = subTitle?.toString().split(".") ?? ["0", "00"];
    return (
      <div className="text-black d-flex flex-column lineHeightSmall">
        <div>
          {whole1}
          <small style={{ marginLeft: "1px" }} id="extra-sm">
            {amount || units ? `.${decimal1 || "00"}` : ""}
          </small>
        </div>
        <div>
          {whole2}
          <small style={{ marginLeft: "1px" }} id="extra-sm">
            {amount || units ? `.${decimal2 || "00"}` : ""}
          </small>
        </div>
      </div>
    );
  };

  return (
    <>
      {simple ? (
        <span>
          <span style={{ letterSpacing: 0, margin: 0, padding: 0 }}>
            {whole}
          </span>
          {(amount || units) && decimal !== undefined ? (
            <>
              <span style={{ margin: 0, padding: 0 }}>.</span>
              <span
                id="extra-sm"
                style={{
                  margin: 0,
                  padding: 0,
                }}
              >
                {decimal || "00"}
              </span>
            </>
          ) : null}
          {(percentage || units) && (
            <span id="extra-sm" className="ml-1">
              {percentage ? "%" : "Units"}
            </span>
          )}
        </span>
      ) : forTxn ? (
        renderTxnAmountPattern()
      ) : (
        <div
          className={`d-flex flex-column lineHeightSmall ${
            theme === "dark" ? " border-white" : "text-black"
          }`}
        >
          {title && <small id={report ? "test" : ""}>{title}</small>}
          <strong id={report ? "test" : ""}>
            <small style={{ marginRight: "1px" }} id="extra-sm">
              {amount ? "Rs." : ""}
            </small>
            {title === "Email" ? subTitle : `${whole}${decimal ? "." : ""}`}
            <small id="extra-sm" style={{ marginLeft: "1px" }}>
              {amount || units || normal_num ? `${decimal || "00"}` : ""}
            </small>
            <small id="extra-sm" className="ml-1">
              {units ? "Units" : percentage ? "%" : ""}
            </small>
          </strong>
        </div>
      )}
    </>
  );
};

export default CardColComponent;
